import React, { useEffect, useState } from "react";
import { Tab, Nav } from "react-bootstrap";
import { UiComponents, UnoStoreHooks } from "@simulanisindia/ui";
import { AppTrainingIcon, BottomActiveBar } from "../../../Icons";
import ResourceTabComponent from "./ResourceTabComponent";
import apiClient from "../../../apiClient";
import { FETCH_METRICS } from "../../../apiClient/apiEndpoints";
import {
  RESOURCE_APPLICATION_TAB,
  RESOURCE_ENVIRONMENT_TAB,
  RESOURCE_MODULE_TAB,
  RESOURCE_SKILL_SCHOOL_TAB,
  RESOURCE_SKILL_STREAM_TAB,
} from "../../../constant/constants";
import ResourceListPanel from "../ResourceListPanel";

const { SimCheckBox } = UiComponents;
const { useUnoSelector } = UnoStoreHooks;

const ResourceTabData = ({
  isMobileView,
  UUID,
  UNO_URL,
  onHandleSelectTab,
  selectCheckBoxAllClicked,
  checkBoxAll,
  setCheckBoxAll,
  selectedResource,
  setSelectedResource,
  activeTab,
  checkedFilterItem,
  setCheckedFilterItem,
}) => {
  const userData = useUnoSelector((state) => state.user);

  const [metricsData, setMetricsData] = useState({
    applicationCount: 0,
    environmentCount: 0,
    moduleCount: 0,
    skillStreamCount: 0,
    skillSchoolCount: 0,
  });

  const fetchMetrics = async () => {
    const data = await apiClient.get(`${UNO_URL}${FETCH_METRICS}/${userData.user.uuid}`);
    setMetricsData(data);
  };

  useEffect(() => {
    fetchMetrics();
  }, [UUID]);

  let allTabs = [
    {
      id_link: RESOURCE_APPLICATION_TAB,
      count: metricsData.applicationCount,
      type: "application",
      searchKey: "application",
      noFilter: true,
      title: "Applications",
      content: {
        component: () => <ResourceTabComponent type="apps" />,
      },
    },
    {
      id_link: RESOURCE_MODULE_TAB,
      count: metricsData.moduleCount,
      searchKey: "module",
      type: "module",
      title: "XR Modules",
      content: {
        component: () => <ResourceTabComponent type="resource" />,
      },
    },
    {
      id_link: RESOURCE_ENVIRONMENT_TAB,
      count: metricsData.environmentCount,
      searchKey: "environment",
      type: "module",
      noFilter: true,
      title: "Enviroments",
      content: {
        component: () => <ResourceTabComponent type="resource" />,
      },
    },
    {
      id_link: RESOURCE_SKILL_STREAM_TAB,
      count: metricsData.skillStreamCount,
      searchKey: "skillstream",
      type: "module",
      noFilter: true,
      title: "Skill Stream Modules",
      content: {
        component: () => <ResourceTabComponent type="resource" />,
      },
    },
    {
      id_link: RESOURCE_SKILL_SCHOOL_TAB,
      count: metricsData.skillSchoolCount,
      searchKey: "skillschool",
      type: "module",
      noFilter: true,
      title: "Skill School Modules",
      content: {
        component: () => <ResourceTabComponent type="resource" />,
      },
    },
  ];

  return (
    <div className="resource-mob">
      <Tab.Container activeKey={activeTab} onSelect={(e) => onHandleSelectTab(null, { id_link: e })}>
        <div className="tabsMobile">
          <Nav variant="pills" className="tabfull">
            {allTabs.map((item) => (
              <Nav.Item key={item.id_link}>
                <Nav.Link eventKey={item.id_link}>
                  <span className="tabCount">{item.count}</span>
                  <span className="tabText">{item.title}</span>
                  <span className="activeIndicator">
                    <BottomActiveBar />
                  </span>
                </Nav.Link>
              </Nav.Item>
            ))}
          </Nav>
        </div>

        <ResourceListPanel
          isMobileView={isMobileView}
          selectCheckBoxAllClicked={selectCheckBoxAllClicked}
          checkBoxAll={checkBoxAll}
          setCheckBoxAll={setCheckBoxAll}
          selectedResource={selectedResource}
          setSelectedResource={setSelectedResource}
          activeTab={activeTab}
          checkedFilterItem={checkedFilterItem}
          setCheckedFilterItem={setCheckedFilterItem}
        />
      </Tab.Container>
    </div>
  );
};

export default ResourceTabData;
